import React, { Suspense, lazy } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { FallbackView } from '../../_metronic/partials'


import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import AuthVerify from '../common/AuthVerify'
import { useAuth } from '../contexts/CustomContextHook/useAuth'
import InvoicePage from '../modules/Invoice/InvoicePage'
// import {MenuTestPage} from '../pages/MenuTestPage'

export function PrivateRoutes() {
  // const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))

  const { UserToken, setUserToken } = useAuth()

  let isUsersClaim = !!JSON.parse(atob(UserToken.token.split('.')[1])).UsersClaim
  let isStatesClaim = !!JSON.parse(atob(UserToken.token.split('.')[1])).StatesClaim
  let isRuleSetsClaim = !!JSON.parse(atob(UserToken.token.split('.')[1])).RuleSetsClaim

  var isAdmin = false;


  if (UserToken.Roles.length > 0) {
    UserToken.Roles.forEach(role => {

      var role = role.replace("[\"", "").replace("\"]", "").toLocaleLowerCase();

      if (role == 'admin') {
        isAdmin = true;
      }
    });
  }


  const UsersPage = lazy(() => import('../modules/User/UserPage'))
  const RolesPage = lazy(() => import('../modules/Role/RolePage'))

  const MenuItemsPage = lazy(() => import('../modules/MenuItems/MenuItemsPage'))
  const MenuPackagesPage = lazy(() => import('../modules/MenuPackages/MenuPackagesPage'))
  const HallPage = lazy(() => import('../modules/Halls/HallsPage'))
  const MarqueeServicePage = lazy(() => import('../modules/MarqueeServices/MarqueeServicesPage'))
  const BookingsPage = lazy(() => import('../modules/Bookings/BookingsPage'))

  const AppSettingsPage = lazy(() => import('../modules/AppSettings/AppSettingsPage'))


  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>

        <Route path='/dashboard' component={DashboardWrapper} />
        <Route path='/menuItems' component={MenuItemsPage} />
        <Route path='/menuPackages' component={MenuPackagesPage} />
        <Route path='/halls' component={HallPage} />
        <Route path='/services' component={MarqueeServicePage} />
        <Route path='/bookings' component={BookingsPage} />
        <Route path='/invoice' component={InvoicePage} />
        <Route path='/appSettings' component={AppSettingsPage} />

        {/* {(isAdmin) && */}
          <Route path='/roles' component={RolesPage} />
        {/* } */}

        <Route path='/users' component={UsersPage} />




        <Redirect from='/auth' to='/dashboard' />

        <Redirect exact from='/' to='/dashboard' />

        {/* <Redirect from='/auth' to='/dashboard' /> */}
        {/* <Redirect exact from='/' to='/dashboard' /> */}
        <Redirect to='error/404' />
      </Switch>
      <AuthVerify />
    </Suspense>
  )
}
